<title>{{ operationalAssurancesNdcHealthCheckDashboardPage.htmlTitle }}</title>
<app-operational-assurances-section [sections]="operationalAssurancesNdcHealthCheckDashboardPage.sections"></app-operational-assurances-section>

<table width="100%" class="incident table table-responsive table-hover">
  <thead>
    <tr>
      <th>Quarterly Results</th>
      <th>Total No. Of Incidents</th>
      <th>Downtime (Hr)</th>
      <th>Service Availability (%) - 99.95% as Target</th>
      <th>P1 : Resolution Time (%) - 100% as Target</th>
      <th>P2 : Resolution Time (%) - 100% as Target</th>
    </tr>
  </thead>
  <tbody *ngFor="let table of tableData; let i = index">
    <tr (click)="toggle(i)">
      <td><i [class.fa-angle-right]="!table.toggle" [class.fa-angle-down]="table.toggle" class="fa"></i> {{ table.quarterlyResults }}</td>
      <td>{{ table.totalNumberOfIncidents }}</td>
      <td>{{ table.downtime }}</td>
      <td [style]="isPriorToQ2_2025(table.quarterlyResults) ? 'color: black;' : (isSLAAchieved(table.serviceAvailability) ? 'color: green;' : 'color: red;')">{{ table.serviceAvailability }}</td>
      <td>{{ table.P1 }}</td>
      <td>{{ table.P2 }}</td>
    </tr>
    <tr [class.dNone]="!table.toggle" *ngFor="let month of table.month">
      <td class="month">{{ month.month }}</td>
      <td>{{ month.totalNumberOfIncidents }}</td>
      <td>{{ month.downtime }}</td>
      <td>{{ month.serviceAvailability }}</td>
      <td>{{ month.P1 }}</td>
      <td>{{ month.P2 }}</td>
    </tr>
  </tbody>
</table>
